import _ from 'lodash';
import apiFetch from '@scale/frontend-lib/api-fetch';
import { VFMParams } from '@scale/shared/demos/types';

export async function vfmPredict(params: VFMParams) {
  const body = _.omitBy(params, _.isNil);
  return await apiFetch<$FIXME>(null, `internal/demos/vfm/predict`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
}
